import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AutenticacaoService } from './autenticacao.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: "root"
})
export class AutenticacaoGuard  {
  

  constructor(
              private autenticacaoService: AutenticacaoService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private cookieService: CookieService
            ) 
  { 

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
      if(this.autenticacaoService.isAuthenticated()){
        return true;
      }else{

        var returnUrl =  window.location.href;

        this.router.navigate(['/autenticacao/login'], { queryParams: { returnUrl: returnUrl }});
        return false;
      }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if(this.autenticacaoService.isAuthenticated()){
      return true;
    }
    else{
      
      var returnUrl =  window.location.href;
      this.autenticacaoService.logout();

      this.router.navigate(['/autenticacao/login'], { queryParams: { returnUrl: returnUrl }});
      
      return false;
    }
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
   
    if(this.autenticacaoService.isAuthenticated()){
      return true;
    }
    else{
      
      var returnUrl =  window.location.href;
      this.autenticacaoService.logout();

      this.router.navigate(['/autenticacao/login'], { queryParams: { returnUrl: returnUrl }});
      
      return false;
    }
  }


}
